

import React, { useState } from 'react';
import image1 from "../img/aaaservices/1 (2).png";
import image2 from "../img/aaaservices/image (18).png";
import image3 from "../img/aaaservices/image (40).png";
import image4 from "../img/aaaservices/image (32).png";
import image5 from "../img/aaaservices/java.avif";
import image6 from "../img/aaaservices/image (87).png";
import image7 from "../img/aaaservices/image (10).png";
import image8 from "../img/aaaservices/fluter.png";
import image9 from "../img/robotics hands working.mp4";
import image10 from "../img/robotics hands working.mp4";
import image11 from "../img/robotics hands working.mp4";
import image12 from "../img/robotics hands working.mp4";
import image13 from "../img/aaaservices/React js v1.jpg";



// Import all banner components
import VertualroboticsBanner from './VertualroboticsBanner';
import Toolfixturebanner from './Toolfixturebanner';
import Digitalfactory from './Digitalfactory';
import JobsOriented from "./JobsOriented";
import Informationtec from './Informationtec';
import Reactbanner from './Reactbanner';
import Pythonbanner from './Pythonbanner';
import Fluuterbanner from './Fluuterbanner';


<style>
{`
h1,h2,h3,h4,h5,h6,p{
font-family: roboto;
}
`}
</style>
const data = {
  "Mechanical Engineering": [
    { title: 'Robotics', subtitle: 'Spaical Offer', image: image1,  },
    { title: 'Virtual Engineering', subtitle: 'Spaical Offer', image: image2, content: 'Virtual engineering allows testing and prototyping virtually before real implementation.' },
    { title: 'Tool and Fixture', subtitle: 'Spaical Offer', image: image3, content: 'Fixtures and tools used in mechanical workshops to assist production.' }
  ],
  "Simulation Engineering": [
    { title: 'Finite Element Analysis', subtitle: 'Spaical Offer', image: image4, content: 'FEA helps predict how a product reacts to real-world forces.' },
    { title: 'CFD', subtitle: 'Fluid dynamics simulations', image: image5, content: 'Computational Fluid Dynamics simulates fluid flow across surfaces.' },
    { title: 'Multi-body Dynamics', subtitle: 'Spaical Offer', image: image6, content: 'Analysis of interconnected rigid or flexible bodies in motion.' }
  ],
  "Informotion Technology": [
    // { title: 'Java', subtitle: 'Spaical Offer', image: image7, content: 'Java is widely used for building enterprise-scale applications.' },
    // { title: 'Python', subtitle: 'Spaical Offer', image: image8, content: 'Python is known for its simplicity and readability, used in data science and AI.' },
    // { title: 'React / Flutter', subtitle: 'Spaical Offer', image: image13, content: 'React is used for web interfaces while Flutter is used for cross-platform apps.' },
    { title: 'Java', subtitle: 'Spaical Offer', image: image7, content: 'Java is widely used for building enterprise-scale applications.' },
    { title: 'Python', subtitle: 'Spaical Offer', image: image8, content: 'Python is known for its simplicity and readability, used in data science and AI.' },
    { title: 'React ', subtitle: 'Spaical Offer', image: image13,  }
  ],
  "Digital Factory Solutions": [
    { title: 'Smart Automation', subtitle: 'Spaical Offer', image: image13, content: 'Integrate intelligent systems to improve production efficiency.' },
    { title: 'IoT Integration', subtitle: 'Spaical Offer', image: image13, content: 'IoT allows real-time monitoring and control across devices.' },
    { title: 'Digital Twin', subtitle: 'Spaical Offer', image: image13, content: 'Create and monitor a digital version of real-world systems for better decision-making.' }
  ]
};

const FilteredCardsPopup = () => {
  const [activeCategory, setActiveCategory] = useState('Mechanical Engineering');
  const [selectedCard, setSelectedCard] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearch = (e) => {
    setSearchTerm(e.target.value.toLowerCase());
  };

  const filteredItems = data[activeCategory].filter(
    item =>
      item.title.toLowerCase().includes(searchTerm) ||
      item.subtitle.toLowerCase().includes(searchTerm)
  );

  const renderBannerComponent = (title) => {
    switch (title) {
      case 'Robotics':
        return <VertualroboticsBanner />;
      case 'Virtual Engineering':
        return <VertualroboticsBanner />;
      case 'Tool and Fixture':
        return <Toolfixturebanner />;
      case 'Smart Automation':
      case 'IoT Integration':
      case 'Digital Twin':
        return <Digitalfactory />;
      case 'Java':
        return <JobsOriented />;
      case 'Python':
        return <Pythonbanner />;
      case 'React ':
        return <Reactbanner/>
        case 'flutter':
        return <Informationtec />;
      default:
        return null;
    }
  };

  return (
    <div className='margicontener' style={{marginTop:'100px'}}>
      <div className="webinarsss" style={{ fontSize: '30px', color: 'black', fontFamily: 'Roboto', fontWeight: 'bold', textAlign: 'center', marginTop: '-15px' }}>
        OUR COURSE <span style={{ color: 'blue' }}>TRAINERS</span>
      </div>

      <div className='rightleftcontener' style={{ display: 'flex', flexDirection: 'row', minHeight: '100vh' }}>
        
  {/* Sidebar */}
  
  <div
  
    style={{
      width: '250px', // fixed width
      // background: '#f4f4f4',
      padding: '1rem',
      height: '255px',
      marginTop: '-4px',
      borderRadius: '30px',
      zIndex: 100,
      // boxShadow: '2px 0 5px rgba(0,0,0,0.2)',
      position: 'releative', // or 'fixed' if needed
      top: '0' // for sticky to work
    }}
  >
    {Object.keys(data).map((category) => (
      <button
        key={category}
        onClick={() => setActiveCategory(category)} // removed setSidebarOpen(false)
        style={{
          display: 'block',
          margin: '0.5rem 0',
          padding: '0.5rem 1rem',
          width: '100%',
          textAlign: 'left',
          background: 'white',
          border: '1px solid #ccc',
          borderRadius: '19px'
        }}
      >
        {category}
      </button>
    ))}
  </div>

        

        {/* Main Content */}
        <div style={{ flex: 1, width: '100%' }}>
         
        {/* <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', padding: '1rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', padding: '0.5rem 1rem', position: 'relative', zIndex: 100 }}>
              <div onClick={() => setSidebarOpen(!sidebarOpen)} style={{ fontSize: '24px', cursor: 'pointer', userSelect: 'none' }}>
                ☰
              </div>
              <input
                type="text"
                placeholder="Search..."
                onChange={handleSearch}
                style={{ flex: 1, padding: '0.5rem 1rem', borderRadius: '6px', border: '1px solid #ccc' }}
              />
            </div>
          </div> */}
          {/* Cards */}
          <div className='cardconte' style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1.5rem', padding: '1rem' }}>
  {filteredItems.map((item, index) => (
    <div
      key={index}
      style={{
        background: 'white',
        borderRadius: '16px',
        boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
        padding: '1rem',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
       
      }}
    >
      <img
        src={item.image}
        alt={item.title}
        style={{ width: '100%', height: '180px', objectFit: 'cover', borderRadius: '12px', marginBottom: '1rem', }}
      />
      <h3 style={{ fontSize: '25px', fontWeight: 'bold', marginBottom: '0.5rem',textAlign:'left' }}>{item.title}</h3>
      <p style={{ fontSize: '30px', color: 'blue', marginBottom: '0.3rem' }}>{item.subtitle}</p>

      {/* New lines added below subtitle */}
      <p style={{ fontSize: '18px', color: '#28a745', fontWeight: '600', marginBottom: '0.2rem' }}>Get Free Training</p>
      <p style={{ fontSize: '18px', color: 'rgb(255 160 0)', fontWeight: 'bold', marginBottom: '1rem' }}>Cost ₹99</p>

      <button
        onClick={() => setSelectedCard(item)}
        style={{
          padding: '0.5rem 1rem',
          background: 'blue',
          color: 'white',
          border: 'none',
          borderRadius: '6px',
          // alignSelf: 'flex-start'
        }}
      >
        Know More
      </button>
    </div>
  ))}
</div>


          {/* Popup */}
          {selectedCard && (
          <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(0,0,0,0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 999
          }}
          onClick={() => setSelectedCard(null)} // <-- click outside to close
        >
          <div
            style={{
              borderRadius: '12px',
              padding: '2rem',
              maxWidth: '1120px',
              width: '90%',
              // background: '#fff',
              position: 'relative'
            }}
            onClick={(e) => e.stopPropagation()} // <-- prevents inside clicks from closing
          >
            {/* <span
              onClick={() => setSelectedCard(null)}
              style={{
                position: 'absolute',
                top: '10px',
                right: '15px',
                cursor: 'pointer',
                fontSize: '28px',
                fontWeight: 'bold',
                color: '#333',
                background: '#eee',
                borderRadius: '50%',
                width: '35px',
                height: '35px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.3s ease',
              }}
              onMouseEnter={(e) => (e.target.style.background = '#ccc')}
              onMouseLeave={(e) => (e.target.style.background = '#eee')}
            >
              &times;
            </span> */}
         
             {/* Popup Content */}
             <div style={{ marginTop: '1.5rem' }}>
               {renderBannerComponent(selectedCard.title)}
             </div>
           </div>
         </div>
         
          )}
        </div>
      </div>
    </div>
  );
};

export default FilteredCardsPopup;

